module.exports = __webpack_public_path__ + "img/audit_slowmist@2x.96a360f5.png";